import { render, staticRenderFns } from "./SiteBreadcrumbs.vue?vue&type=template&id=5c0a9424&scoped=true&"
import script from "./SiteBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./SiteBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./SiteBreadcrumbs.vue?vue&type=style&index=0&id=5c0a9424&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0a9424",
  null
  
)

export default component.exports